<template>
  <div class="px-4 sm:px-0">
    <div class="flex-col hidden h-full left-side sm:p-6 sm:pr-6 sm:pb-0 lg:pb-0 lg:p-16 lg:pr-32 rounded-l-xl sm:flex">
      <div
        v-if="hasReferralCode"
        class="text-3xl font-bold text-b30 referral-title"
      >
        You've been invited to get
        <span class="title-gradient">2 extra months</span>
        on an Annual plan
      </div>
      <div
        v-else
        class="text-3xl font-bold text-b30"
      >
        Start discovering <br> Motion Array for free
      </div>
      <ul class="mt-3 features-ul">
        <li
          v-if="hasPromo && !hasHolidayPromo"
          class="flex items-center text-b30"
        >
          <i class="fa-solid fa-gift text-gradient" />
          <span class="font-medium">Save {{ currencySymbol }}50 when you subscribe today</span>
        </li>
        <li
          v-if="hasPromo && hasHolidayPromo"
          class="promo flex text-b30"
        >
          <i class="fa-solid fa-gift" />
          <span class="font-medium">Get 15% off an annual plan when you subscribe today</span>
        </li>
        <li
          v-for="(item, index) in featuresList"
          :key="index"
          class="flex items-center text-b30"
        >
          <i class="fa-regular fa-check" />
          <span>{{ item }}</span>
        </li>
      </ul>
      <img
        v-if="hasReferralCode"
        class="mt-12"
        :src="getAssetPath('signup_v3.png')"
        alt="Signup"
      >
      <img
        v-else
        class="mt-12"
        :src="getAssetPath('signup_v2.png')"
        alt="Signup"
      >
    </div>
    <div
      v-if="!isShowMobileForm"
      class="w-full pt-3 pb-4 flex-col mt-0 sm:hidden px-5"
    >
      <div
        v-if="hasReferralCode"
        class="text-2xl font-bold text-b30 referral-title"
      >
        You've been invited to get
        <span class="title-gradient">2 extra months</span>
        on an Annual plan
      </div>
      <div
        v-else
        class="text-2xl font-bold text-b30"
      >
        Create your free account
      </div>
      <ul
        class="mt-3 features-ul px-0"
      >
        <li
          v-if="hasPromo && hasHolidayPromo"
          class="promo flex text-b30"
        >
          <i class="fa-solid fa-gift" />
          <span class="font-medium">Get 15% off an annual plan when you subscribe today</span>
        </li>
        <li
          v-for="(item, index) in mobileFeaturesList"
          :key="index"
          class="flex items-center text-b40"
        >
          <i class="fa-regular fa-check" />
          <span>{{ item }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getAssetPath } from '@/utils/contentDelivery';
import { CURRENCY_SYMBOLS } from '@/constants/currencies';

export default {
  components: {
  },
  inject: ['hasPromo', 'hasHolidayPromo'],
  props: {
    isShowMobileForm: {
      type: Boolean,
      default: true,
    },
    hasReferralCode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    featuresList() {
      if (this.hasReferralCode) {
        return [
          'Unlimited access to 2M+ templates, songs, SFX, video clips and more',
          'License covers every project worldwide',
          '50+ professional plugins compatible with all major editing software',
        ];
      }
      return [
        '100s of free video templates',
        '100s of free songs & SFX',
        'Dozens of free graphic assets',
        'New free assets sent to your email regularly',
        'A catalog of 2M+ video templates, songs, motion graphics & more to explore',
      ];
    },
    mobileFeaturesList() {
      if (this.hasReferralCode) {
        return [
          'Unlimited access to 2M+ templates, songs, SFX, video clips and more',
          'License covers every project worldwide',
          '50+ professional plugins compatible with all major editing software',
        ];
      }
      return [
        '100s of free creative assets',
        'Exclusive free assets in your inbox',
        'Explore 2M+ templates, songs, motion graphics & more',
      ];
    },
    currencyCode() {
      return this.$store.state.currencyCode;
    },
    // in Nuxt need to use currencyMixin
    currencySymbol() {
      return CURRENCY_SYMBOLS[this.currencyCode];
    },
  },
  methods: {
    getAssetPath,
  },
};
</script>

<style scoped>
.left-side {
    background-image: url(https://assets.motionarray.com/signup-bg.jpg);
    background-repeat: no-repeat;
    background-size: cover;
}
.features-ul li {
  max-width: 350px;
}
.features-ul li.promo {
  max-width: 385px;
}
.features-ul li {
    @apply mt-4;
    font-variant-numeric: lining-nums;
}
.features-ul i {
    @apply pr-3 text-base text-ma;
}
.features-ul .promo i {
  color: #0a00b5;
  padding-top: 2px;
}
.features-ul + img.mt-12 {
    width: 90%;
    margin: auto;
    margin-top: 2rem;
}
.text-gradient {
  background: linear-gradient(to right, #9555CD, #D40263);
  -webkit-background-clip: text;
  -moz-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
}
@media (orientation: landscape) and (max-height: 480px) {
  .left-side {
    display: none;
  }
}
.referral-title {
  max-width: 300px;
}
.title-gradient {
  background: linear-gradient(127deg, #534cda 0%, #ffbec7 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
@screen lg {
  .referral-title {
    max-width: 350px;
  }
}
</style>
